"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=collection.total.status.summary.js.map